module.exports = "<div class=\"dropletBubble-fieldContainer\" :id=\"'drp-' + activeDroplet._id\">\n  <div class=\"drzVideo-loader dropletBubble-video-loader\" aria-hidden=\"true\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/video-player/components/_preview/loader/template.html
// module id = sT8Q
// module chunks = 0